import { transformBreakDetailOnGet } from '$models'
import { setCompanyTimeZone } from 'src/components/common/helpers'
import {
  BreakResponse,
  DefaultHoursShiftResponse,
  IClockinResponse,
  ILeaveShiftResponse,
  RosteredShiftResponse,
} from '@loadedhub/core-api-sdk'

export type {
  ClockinResponse,
  IClockinResponse,
  LeaveShiftResponse,
  ILeaveShiftResponse,
} from '@loadedhub/core-api-sdk'

export type IShiftResponse =
  | IClockinResponse
  | RosteredShiftResponse
  | DefaultHoursShiftResponse
  | ILeaveShiftResponse

export const transformClockinDetailOnGet = (
  clockinDetail: IClockinResponse
): IClockinResponse => {
  return {
    ...clockinDetail,
    clockinTime: setCompanyTimeZone(clockinDetail.clockinTime),
    clockoutTime: clockinDetail.clockoutTime
      ? setCompanyTimeZone(clockinDetail.clockoutTime)
      : undefined,
    breaks: clockinDetail.breaks.map(
      transformBreakDetailOnGet
    ) as BreakResponse[],
  }
}
